module.exports = __webpack_public_path__ + "static/images/website.8ff23906af501689b5d0679cc6da1732.svg";